import { connect } from "react-redux"
import { compose } from "redux"
import ProgressReportsOverview from '../components/progress-reports-overview'
import { getVariables } from "../utilities/route"
import { withData } from "../decorators/with-data"
import gql from "graphql-tag"
import { withTranslations } from "../decorators/with-translations"
import { setPrFilters, setSubmitError } from '../actions/survey'
import { toNormalizedRespondentFilters } from '../utilities/helpers'
import { withImprovementProjectData } from './withImprovementProjectData'
import { getPreviousSurveyId } from '../utilities/progress-reports'

const query = gql`
  query ProgressPage(
    $currentSurveyId: UUID!
    $previousSurveyId: UUID!
    $respondentFilters: [RespondentFilterInput!]
    $languageCode: String
  ) {
    currentEngagement: afterGameRespondentCountOverview(
      surveyId: $currentSurveyId
    ) {
      answeredRespondentCount
      invitedRespondentCount
      engagementPercentage
    }
    previousEngagement: afterGameRespondentCountOverview(
      surveyId: $previousSurveyId
    ) {
      answeredRespondentCount
      invitedRespondentCount
      engagementPercentage
    }
    currentSurveyStatistics: surveyStatistics(
      surveyId: $currentSurveyId
      respondentFilters: $respondentFilters
      languageCode: $languageCode
    ) {
      __typename
      ... on SurveyStatisticsOutput {
        overallAggregatedResponse
        themes { id aggregatedResponse aggregatedImportance }
        drivers { id aggregatedResponse aggregatedImportance }
        questions { id aggregatedResponse aggregatedImportance totalRespondentCount skippedRespondentCount }
      }
    }
    previousSurveyStatistics: surveyStatistics(
      surveyId: $previousSurveyId
      respondentFilters: $respondentFilters
      languageCode: $languageCode
    ) {
      __typename
      ... on SurveyStatisticsOutput {
        overallAggregatedResponse
        themes { id aggregatedResponse aggregatedImportance }
        drivers { id aggregatedResponse aggregatedImportance }
        questions { id aggregatedResponse aggregatedImportance totalRespondentCount skippedRespondentCount }
      }
    }
  }
`;

const mapStateToProps = ({ survey: { prFilters, submitError } }) => {
  return {
    prFilters,
    submitError
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    onSetPrFilters: prFilters => {
      dispatch(setPrFilters(prFilters))
    },
    onSubmitError: (error) => {
      dispatch(setSubmitError(error));
    }
  };
};

export default compose(
  withTranslations,
  connect(mapStateToProps, mapDispatchToProps),
  withData(query, {
    props: ({data}) => ({
      ...data,
      loading: data.loading,
    }),
    options: (props) => {
      const variables = { ...getVariables(props) }

      variables.variables.respondentFilters = toNormalizedRespondentFilters(props.prFilters);

      variables.variables.currentSurveyId = variables.variables.surveyId;
      delete variables.variables.surveyId;
      variables.variables.previousSurveyId = getPreviousSurveyId(
        props.questionnaire.surveySequence,
        variables.variables.currentSurveyId
      );

      return {
        ...variables,
        fetchPolicy: "network-only",
      };
    },
  }),
  withImprovementProjectData,
)(ProgressReportsOverview)



// WEBPACK FOOTER //
// ./src/containers/progress-reports-overview.js